import React from 'react'
import { useMount } from 'react-use'

import { useSearchParamOrFail } from '@/hooks/useSearchParamOrFail'
import { SEARCH_PARAMS } from '@/lib/searchParams'

// Given a 'redirectTo' search param, this page will redirect to that value.
const RedirectPage: React.FC = () => {
  const redirectTo = useSearchParamOrFail(SEARCH_PARAMS.redirect.redirectTo)

  useMount(() => {
    window.location.assign(redirectTo)
  })

  return <>Redirecting...</>
}

export default RedirectPage
